/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ApiGatewayStripeCustomerDetailsDto } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class StripeController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags stripe-controller
   * @name GetStripeCustomerDetails
   * @request GET:/api/v1/stripe/customer
   */
  getStripeCustomerDetails = (params: RequestParams = {}) =>
    this.http.request<ApiGatewayStripeCustomerDetailsDto, any>({
      path: `/v1/stripe/customer`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getStripeCustomerDetailsPath = '/v1/stripe/customer'
  static getStripeCustomerDetailsMethod = 'GET'
}
